import { Link } from 'wouter'

export default function NotFoundPage() {
  return (
    <div className="grid min-h-[60vh] place-items-center rounded-[2rem] border border-white/10 bg-[#171c36] px-6 text-center text-slate-200">
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#f18a70]">Tecma</p>
        <h1 className="mt-3 text-3xl font-black uppercase text-white">Page not found</h1>
        <p className="mt-3 text-sm leading-7 text-slate-300">Return to Tecma home or open workshop view.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link href="/" className="inline-flex items-center justify-center border border-[#f18a70] bg-[#f18a70] px-4 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5">
            Home
          </Link>
          <Link href="/workshop" className="inline-flex items-center justify-center border border-white/15 bg-white/5 px-4 py-2 text-sm font-bold text-white transition hover:bg-white/10">
            Workshop
          </Link>
        </div>
      </div>
    </div>
  )
}
